"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcCrumbsBreak = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 5 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M4.47656 2.99609H3.17969L0 17.0039H1.29688L4.47656 2.99609Z" }) })));
exports.default = IcCrumbsBreak;
